import React from "react";
import { func, string, object } from "prop-types";
import { validateUser } from "../../../../api/utils";
import { useGoogleOneTapLogin } from "@react-oauth/google";

const OneTapLogin = ({ member, setMember, redirectURL }) => {
  const onLogin = (res) => {
    validateUser(res.credential, redirectURL)
      .then((userData) => {
        console.log("User data from Google One-Tap:", userData.user);
        setMember(userData.user);
      })
      .catch((error) => console.log("Error in one tap login", error));
  };

  useGoogleOneTapLogin({
    onSuccess: (res) => onLogin(res),
    onError: (error) => {
      console.log("one tap Login Failed", error);
    },
    disabled: member,
    cancel_on_tap_outside: false,
    use_fedcm_for_prompt: true,
    use_fedcm_for_button: true,
  });

  return null;
};

OneTapLogin.propTypes = {
  member: object,
  setMember: func.isRequired,
  redirectURL: string,
};

export default OneTapLogin;
